const benefits = [
  {
    icon: 'ri-shield-check-line',
    title: '正版授权',
    description: '所有漫画均获得韩国出版社官方授权，让您安心阅读每一页',
  },
  {
    icon: 'ri-smartphone-line',
    title: '下拉式阅读',
    description: '专为网页端和移动端优化的竖屏下拉式阅读体验，流畅自然',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    description: '全彩高清漫画，细节清晰可见，还原韩国漫画家原汁原味的笔触',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    description: '韩国本土更新后24-48小时内完成汉化上线，追更无需等待',
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            为什么选择韩漫之家
          </h2>
          <p className="text-sm text-foreground-500 mt-2">用心打造最好的韩漫阅读平台</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {benefits.map((item, index) => (
            <div key={index} className="text-center p-6">
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}